// extracted by mini-css-extract-plugin
export default {"e_year":"area_e_year__gq1jK"};